"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLambdaError = isLambdaError;
/**
 * Is the Error a LambdaError, which has a statusCode.
 *
 * @param {(LambdaError | Error)} error
 * @returns {error is LambdaError}
 */
function isLambdaError(error) {
    return !!error && error.statusCode !== undefined;
}
//# sourceMappingURL=Guards.js.map